export default __webpack_public_path__ + "static/media/rightGrey.d7c3b304.svg";